// extracted by mini-css-extract-plugin
export default {"container":"Collapsible_container__9aG5q","header":"Collapsible_header__-tt9j","body":"Collapsible_body__JFodP"};